import React, { useState } from 'react';
import { connect } from 'react-redux';

// Bootstrap Imports
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

// Fontawessome Imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';

// Redux Functions Imports
import { signOut, signUp } from '../../../store/actions/authActions';

const RegisterLeadsForm = (props) => {
	// Props Destructuring
	const {
		// auth,
		loading,
		onHide,
		signOut,
		signUp,
		signUpAuthError,
		show,
	} = props;

	// Component State
	const [newUser, setNewUser] = useState({
		email: '',
		password: '',
		confirmPassword: '',
	});
	const [error, setError] = useState({});
	const [discountObteined, setDiscountObteined] = useState(false);

	// Component Functions
	const closeModal = () => {
		setTimeout(() => {
			onHide();
		}, 300);
	};
	const handleChange = (e) => {
		setNewUser({ ...newUser, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const objError = {};

		if (!newUser.email || !newUser.password || !newUser.confirmPassword) {
			!newUser.email && (objError.email = 'El email no puede estar vacio');
			!newUser.password &&
				(objError.password = 'La contraseña no puede estar vacia');
			!newUser.confirmPassword &&
				(objError.confirmPassword = 'Debes confirmar tu contraseña');

			setError(objError);
		} else if (
			!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(newUser.email)
		) {
			setError({ email: 'El email debe ser válido' });
		} else if (
			newUser.password.length <= 6 ||
			newUser.confirmPassword.length <= 6
		) {
			newUser.password.length <= 6 &&
				(objError.password = 'La contraseña es demasido corta');
			newUser.confirmPassword.length <= 6 &&
				(objError.confirmPassword = 'La contraseña es demasido corta');

			setError(objError);
		} else if (newUser.password !== newUser.confirmPassword) {
			setError({
				password: 'Las contraseñas no coinciden',
				confirmPassword: 'Las contraseñas no coinciden',
			});
		} else {
			setTimeout(() => {
				signUp(newUser);
				console.log(newUser);
				setError({});
				signOut();
				setDiscountObteined(true);
			}, 300);
			setTimeout(() => {
				onHide();
			}, 4000);
		}
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			size='lg'
			aria-labelledby='contained-modal-title-vcenter'
			centered>
			<Modal.Header className='custom-form-header'>
				<Modal.Title id='contained-modal-title-vcenter'>
					No te lo pierdas
				</Modal.Title>
				<div className='close-modal-btn' onClick={closeModal}>
					<FontAwesomeIcon icon={faTimes} style={{ fontSize: '1.15rem' }} />
				</div>
			</Modal.Header>
			<Form onSubmit={handleSubmit} noValidate>
				<Modal.Body>
					<div className='form-image-container'>
						<Image
							src='img/de-la-venta-tradicional-a-la-digital.jpg'
							alt='De la venta tradicional a la venta digital en un click'
							className='engagement-form-image'
						/>
					</div>
					<p className='mb-1'>
						Subscríbete y obten 20% de descuento en mi curso{' '}
						<strong>
							"De la venta tradicional a la venta digital en un click"
						</strong>
						.
					</p>
					<div
						className='d-flex flex-column align-items-center justify-content-center'
						style={{ width: '100%', minHeight: 192 }}>
						{loading ? (
							<Spinner
								animation='grow'
								style={{ backgroundColor: '#3c1375' }}
							/>
						) : discountObteined ? (
							<div className='discount-completed'>
								<FontAwesomeIcon
									icon={faCheckCircle}
									className='my-3'
									style={{ fontSize: '3.5rem', color: '#3c1375' }}
								/>
								<h4 className='mb-3'>Tu descuento se ha registrado</h4>
								<p className='mb-0'>
									Pronto recibirás un correo de confirmación.
								</p>
							</div>
						) : (
							<div style={{ width: '100%' }}>
								<Form.Group controlId='email'>
									<Form.Label className='label-form-style'>Email</Form.Label>
									<Form.Control
										type='email'
										name='email'
										placeholder='Registra tu email'
										onChange={handleChange}
										isInvalid={error.email || signUpAuthError}
									/>
									{(error.email || signUpAuthError) && (
										<Form.Control.Feedback
											type='invalid'
											style={{ paddingLeft: 10 }}>
											{error.email || signUpAuthError}
										</Form.Control.Feedback>
									)}
								</Form.Group>
								<Form.Group controlId='password'>
									<Form.Label className='label-form-style'>
										Contraseña
									</Form.Label>
									<Form.Control
										type='password'
										name='password'
										placeholder='Crea una contraseña'
										onChange={handleChange}
										isInvalid={error.password}
									/>
									{error.password && (
										<Form.Control.Feedback
											type='invalid'
											style={{ paddingLeft: 10 }}>
											{error.password}
										</Form.Control.Feedback>
									)}
								</Form.Group>
								<Form.Group controlId='confirmPassword'>
									<Form.Label className='label-form-style'>
										Confirmar contraseña
									</Form.Label>
									<Form.Control
										type='password'
										name='confirmPassword'
										placeholder='Confirma tu contraseña'
										onChange={handleChange}
										isInvalid={error.confirmPassword}
									/>
									{error.confirmPassword && (
										<Form.Control.Feedback
											type='invalid'
											style={{ paddingLeft: 10 }}>
											{error.confirmPassword}
										</Form.Control.Feedback>
									)}
								</Form.Group>
							</div>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						block
						disabled={loading}
						type='submit'
						className='lead-form-btn'>
						{loading ? 'Creando descuento...' : 'Obtener Descuento'}
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		signUpAuthError: state.auth.signUpAuthError,
		auth: state.firebase.auth,
		loading: state.auth.loading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		signUp: (newUser) => dispatch(signUp(newUser)),
		signOut: () => dispatch(signOut()),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterLeadsForm);
